/**
 * API base URL for auth and other backend calls.
 *
 * Create React App reads env at **build** time from the usual files, e.g.
 * `.env.development`, `.env.production` (see CRA docs).
 * Set `REACT_APP_API_BASE_URL` in `.env.development` for `npm start`.
 *
 * Staging uses `.env.staging`, loaded via `env-cmd` (`npm run start:staging` /
 * `npm run build:staging` in `frontend/`).
 *
 * If `REACT_APP_API_BASE_URL` is missing or empty after trim, the app uses
 * `https://api.digirasa.com`.
 */
const trimTrailingSlash = (url) => String(url || '').replace(/\/+$/, '');

const DEFAULT_API_BASE_URL = 'https://api.digirasa.com';

const apiEnvRaw = (process.env.REACT_APP_API_ENV || 'production').toLowerCase();

const normalizedEnv = ['production', 'development', 'staging'].includes(apiEnvRaw)
  ? apiEnvRaw
  : 'production';

export const API_ENV = normalizedEnv;

const fromEnv = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL || '');

export const API_BASE_URL = fromEnv || DEFAULT_API_BASE_URL;

/** Optional separate host for menu/item images (e.g. staging API + production uploads). */
const imageFromEnv = trimTrailingSlash(process.env.REACT_APP_IMAGE_BASE_URL || '');

export const IMAGE_BASE_URL = imageFromEnv || API_BASE_URL;
